"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _polished = require("polished");

var _input = require("./input.const");

var _zIndex = _interopRequireDefault(require("../choices/zIndex.const"));

var _timing = _interopRequireDefault(require("../choices/timing.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

var _color = _interopRequireDefault(require("../choices/color.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var timeSelector = {
  input: Object.assign({}, _input.input),
  dropdownAnimationDuration: _timing["default"].fast,
  dropdownZIndex: _zIndex["default"].z3000,
  dropdownBorderSize: _size["default"].borderSizeDefault,
  dropdownBorderColor: _color["default"].cloudyBlue300,
  dropdownBorderRadius: 0,
  dropdownShadowBlurRadius: _size["default"].small,
  dropdownShadowColor: (0, _polished.rgba)(_color["default"].cloudyBlue300, 0.6),
  dropdownFontSize: _font["default"].sizeSm,
  dropdownLineHeight: _font["default"].lineHeightSm,
  dropdownFontFamily: _font["default"].family,
  dropdownWidth: '140px',
  dropdownMaxHeight: '160px',
  listItemPadding: "".concat(_spacing["default"].xxs, " ").concat(_spacing["default"].xs),
  listItemBackground: _color["default"].white,
  listItemBackgroundHover: _color["default"].cloudyBlue100,
  listItemBackgroundSelected: _color["default"].dodgerBlue100,
  listItemColor: _color["default"].pickledBluewood
};
var _default = timeSelector;
exports["default"] = _default;